import logo from "~/assets/niche-logo.svg";
import Image from "~/components/atoms/Image";

export function PoweredByNiche() {
    return (
        <div className="flex gap-1">
            <span className="relative top-[6px] text-[10px]">Powered by</span>
            <Image alt="Niche" src={logo} width={60} />
        </div>
    );
}
